function init(el) {
    const tabs = [...el.querySelectorAll('.ci-tab')]
    
    function openTab() {
        const tabActive = el.querySelector('.ci-tab.active')
        const tabContentActive = el.querySelector('.ci-content.active')
        
        const tabID = this.getAttribute('data-tab')
        const newTab = el.querySelector(`[id="${tabID}"]`)
        
        // Remove current active state and reinstate current
        tabContentActive.classList.remove('active');
        newTab.classList.add('active');

        // Remove current active state and reinstate current
        tabActive.classList.remove('active');
        this.classList.add('active');    
    }
    
    tabs.map(tab => tab.addEventListener('click', openTab))
}

export default () => {
    const tabbed = [...document.querySelectorAll('.ci-tabbed-content')]
    tabbed.map(init)
}
